<template>
    <div id="content">
        <loader></loader>
        <div class="top">
            <div class="header">
                <h1>Primes de {{user.firstname}} {{user.lastname}}</h1>
                <div class="pageOptions">
                    <btn text="Ajouter" ico="add" @click="add" v-if="$store.getters.hasPerm('prime:edit')"></btn>
                </div>
            </div>
        </div>
        <div class="table-responsive no-search">
            <table>
                <thead>
                    <tr>
                        <th>Mois</th>
                        <th>Année</th>
                        <th>Prime</th>
                        <th>Prime Exceptionnelle</th>
                        <th>Total</th>
                        <th>Options</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(prime,key) in primes">
                        <td>{{month[prime.month]}}</td>
                        <td>{{prime.year}}</td>
                        <td>{{prime.prime_total}} €</td>
                        <td>{{prime.prime_exceptionnelle}} €</td>
                        <td>{{parseFloat(prime.prime_total) + parseFloat(prime.prime_exceptionnelle)}} €</td>
                        <td class="tableOptions">
                            <div @click="edit(prime.id)" v-if="$store.getters.hasPerm('prime:show')" title="Voir le détail de la prime">
                                <svg class="option"><use xlink:href="#icon-eye"></use></svg>
                            </div>
                            <div @click="edit(prime.id)" v-if="$store.getters.hasPerm('prime:edit')" title="Modifier la primes">
                                <svg class="option"><use xlink:href="#icon-edit"></use></svg>
                            </div>
                        </td>
                    </tr>
                    <tr v-if="primes.length <= 0">
                        <td colspan="5" style="text-align: center">Il n'y a aucune prime</td>
                    </tr>
                </tbody>
            </table>
        
        </div>
    </div>
</template>

<script>
import Loader from "@/components/Loader";
import Btn from "@/components/Btn";
import moment from 'moment';
import axios from "axios";
import tools from "@/config";

export default {
    name: "Primes",
    components: {Loader, Btn},
    data() {
        return {
            user_id: 0,
            user:{},
            primes:[],
            month:["","Janvier","Février","Mars","Avril","Mai","Juin","Juillet","Août","Septembre","Octobre","Novembre","Décembre"],
        }
    },
    methods: {
        async load() {
            
            if (!this.user_id) {
                tools.loader(false);
                return;
            }
            
            tools.loader(true);
            
            let response = await axios.get(tools.api("user/" + this.user_id+"/primes"), tools.headerGET())
            this.primes = response.data;
            
            tools.loader(false);
        },
        async loadUser() {
            
            if (!this.user_id) {
                tools.loader(false);
                return;
            }
            
            tools.loader(true);
            
            let response = await axios.get(tools.api("user/" + this.user_id), tools.headerGET())
            this.user = response.data;
            
            tools.loader(false);
        },
        add(){
            this.$router.push("/user/"+this.user_id+"/prime/0")
        },
        edit(id){
            this.$router.push("/user/"+this.user_id+"/prime/"+id)
        }
    },
    async mounted() {
        this.user_id = this.$route.params.id;
        
        await this.load();
        await this.loadUser();
        
    }
}
</script>